import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

/**
 * Tailwind CSS sınıflarını birleştiren yardımcı fonksiyon
 * @param  {string[]} inputs - Birleştirilecek sınıf isimleri
 * @returns {string} - Birleştirilmiş ve optimize edilmiş sınıf ismi
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Sayıları Türkçe formatında biçimlendirir (binler için nokta, ondalık için virgül)
 * @param {number} value - Biçimlendirilecek sayı
 * @param {number} decimals - Ondalık basamak sayısı (varsayılan: 2)
 * @returns {string} - Biçimlendirilmiş sayı dizesi
 */
export function formatNumber(value, decimals = 2) {
  if (value === null || value === undefined) return '';
  
  // Eğer değer bir tam sayıya çok yakınsa (örn. 229.99999999999997), en yakın tam sayıya yuvarla
  // Bu özellikle cm değerlerinde kullanışlı olacak
  if (Math.abs(Math.round(value) - value) < 0.001) {
    value = Math.round(value);
  }
  
  // Sayıyı belirtilen ondalık basamak sayısına yuvarla
  const roundedValue = Number(value).toFixed(decimals);
  
  // Sayıyı parçalara ayır
  const parts = roundedValue.toString().split('.');
  
  // Tam kısmı binlik ayırıcıyla biçimlendir
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  
  // Ondalık kısmı virgülle birleştir
  return parts.join(',');
}
